import React from 'react';
import LoadingIndicator from 'components/common/loading/LoadingIndicator';
import NoLoading from 'components/error/NoLoading';

const LoadableLoading = props => {
    if (props.error) {
        console.log(props.error);
        return <NoLoading error={props.error} onRetry={props.retry}/>;
    } else if (props.pastDelay) {
        return <LoadingIndicator isLoading={true}/>;
    } else {
        return null;
    }
};

export default LoadableLoading;